import operatorApiFetch from './apiService';

export const webhookDeliveryService = {
  getList: async (params) => {
    const query = new URLSearchParams(params).toString();
    const response = await operatorApiFetch(`webhook_deliveries?${query}`);
    return response.json();
  },
  getRecords: async (params) => {
    const response = await operatorApiFetch('webhook_deliveries/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },
  get: (id) => operatorApiFetch(`webhook_deliveries/${id}`),
  retry: (id) => operatorApiFetch(`webhook_deliveries/${id}/retry`, { method: 'POST' }),
};
